import { BidStatus, NegotiationRoundStatus, type PortalNegotiationRoundDto } from "../../../../autogen/bff-api";

export type RoundExitReason = "noAnswer" | "declined";

export interface RoundExit {
  round: PortalNegotiationRoundDto;
  reason: RoundExitReason;
}

export const isPortalRoundClosed = (round: PortalNegotiationRoundDto, now: number = Date.now()): boolean =>
  round.status === NegotiationRoundStatus.Completed ||
  (round.status === NegotiationRoundStatus.Published && Date.parse(round.deadline) <= now);

export const roundExit = (rounds: readonly PortalNegotiationRoundDto[], now: number = Date.now()): RoundExit | null => {
  if (rounds.some((round) => round.isCallerRejected)) return null;
  const latest = rounds
    .filter((round) => round.isCallerInvited)
    .sort((a, b) => a.roundNumber - b.roundNumber)
    .at(-1);
  if (!latest || !isPortalRoundClosed(latest, now) || latest.missingLeavesCompetition === false) return null;
  if (latest.myBid != null && latest.myBid.status !== BidStatus.Draft) return null;
  return { round: latest, reason: latest.declinedAt != null ? "declined" : "noAnswer" };
};
